__turbopack_context__.v({
  "accordion": "FilterAccordion-module__BLNNSa__accordion",
  "accordion__content": "FilterAccordion-module__BLNNSa__accordion__content",
  "accordion__icon": "FilterAccordion-module__BLNNSa__accordion__icon",
  "accordion__section": "FilterAccordion-module__BLNNSa__accordion__section",
  "accordion__text": "FilterAccordion-module__BLNNSa__accordion__text",
  "accordion__title": "FilterAccordion-module__BLNNSa__accordion__title",
  "active": "FilterAccordion-module__BLNNSa__active",
  "filerSection": "FilterAccordion-module__BLNNSa__filerSection",
  "modal": "FilterAccordion-module__BLNNSa__modal",
  "modalBody": "FilterAccordion-module__BLNNSa__modalBody",
});
